<template>
  <div class="gender-filter" v-if="genders.length>0">
    <div
      class="toggle"
      :class="{
        open: open && isMobile,
        bold: !open && selected && selected.length > 0,
      }"
      @click="open = !open"
    >
      <div class="icon"></div>
      <div v-if="isMobile" class="text">
        {{ open ? t("close") : t("filter_by_gender") }}
      </div>
      <div v-else class="text">{{ t("filter_by_gender") }}</div>
    </div>
    <transition name="fade">
      <div class="options" v-if="!isMobile || open">
        <ul class="options-list">
          <li class="options-item" v-for="gender in genders" :key="gender.id">
            <checkbox
              :value="isSelected(gender.id)"
              @input="() => handleClick(gender.id)"
              :label="gender.label"
            ></checkbox>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import { getPossibleGenders } from "../../services/Api";
import Checkbox from "../Checkbox.vue";
export default {
  props: {
    selected: { type: Array },
    // selected:{type:Array, default:()=>[] },
  },
  model: {
    prop: "selected",
    event: "change",
  },
  components: {
    Checkbox,
  },
  data() {
    return {
      open: true,
    };
  },
  mounted() {
    if (this.isMobile) this.open = false;
  },
  asyncComputed:{
    gendersFamilies(){
      return getPossibleGenders()
    }
  },
  computed: {
    internalSelection: {
      get() {
        return this.selected || [];
      },
      set(val) {
        this.$emit("change", val);
      },
    },
    genders() {
      if(!this.gendersFamilies) return []
      return [
        {
          id: "MU",
          label: this.t("for_him"),
        },
        {
          id: "FU",
          label: this.t("for_her"),
        },
        {
          id: "U",
          label: this.t("unisex"),
        },
      ].filter(obj => this.gendersFamilies.includes(obj.id))
    },
  },
  methods: {
    handleClick(category) {
      if (this.isSelected(category)) {
        this.internalSelection.splice(
          this.internalSelection.indexOf(category),
          1
        );
      } else {
        this.internalSelection.push(category);
      }
    },
    isSelected(category) {
      return this.internalSelection.includes(category);
    },
  },
  watch: {
    open() {
      if (!this.isMobile) this.internalSelection = [];
    },
  },
};
</script>

<style lang="stylus" scoped>
.gender-filter
  .toggle
    align-items: center
    background-color: #fff
    border: 1px solid $golden
    border-radius: 2px
    cursor: pointer
    display: flex
    height: vw(40px)
    padding: vw(10px) vw(20px)
    width: fit-content
    z-index: 2

    &.open
      .icon
        m-icon("close", 18)

    &.bold
      .text
        font-weight: bold

    .icon
      m-icon("filters", 16)
      margin-right: vw(10px)

    .text
      m-font-size(14, 22)
      m-letter-spacing(20)

  .options
    background-color: #fff
    border: 1px solid $golden
    border-radius: 2px
    margin-top: vw(4px)
    max-height: vh(300px)
    overflow: hidden
    padding: vw(15px)
    right: 0
    top: vw(45px)
    width: vw(220px)
    z-index: 1

    &.fade-enter-active
      transition: all 0.4s

    &.fade-leave-active
      transition: all 0.4s

    &.fade-enter,
    &.fade-leave-to
      max-height: 0
      opacity: 0
      top: vw(20px)
      width: vw(100px)

    .mobile &
      margin-top: 0
      position: absolute

  .options-item
    &:not(:last-child)
      margin-bottom: vw(10px)
</style>